import axios from 'axios';
import React, { createContext, useEffect, useState, useContext } from 'react';
import { UserContext } from './UserContext';
import { SrxApi } from '../api/SrxApi';

export const ShowResolvedAlertsContext = createContext();

export const ShowResolvedAlertsProvider = (props) => {

    const { user } = useContext(UserContext);

    const [showResolved, setShowResolved] = useState(true);

    useEffect(() => {
        // First, prefer a locally persisted value so refresh keeps the user's choice
        const localVal = localStorage.getItem('widget_hideResolvedAlerts_Show');
        if (localVal !== null) {
            setShowResolved(localVal === 'true');
            return;
        }

        if (!user || !user.userSettings) {
            setShowResolved(false);
            return;
        }

        const settings = user.userSettings;
        let resolvedValue = false;
        if (settings && typeof settings === 'object') {
            resolvedValue = settings.widget_hideResolvedAlerts_Show === 'true';
        }
        setShowResolved(resolvedValue);
    }, [user]);

    // Persist any changes to showResolved to localStorage so it survives page refresh
    useEffect(() => {
        try {
            localStorage.setItem('widget_hideResolvedAlerts_Show', showResolved ? 'true' : 'false');
        } catch (err) {
            console.debug('Could not persist widget_hideResolvedAlerts_Show to localStorage', err);
        }
    }, [showResolved]);
    return (
        <ShowResolvedAlertsContext.Provider value={{ showResolved, setShowResolved }}>
            {props.children}
        </ShowResolvedAlertsContext.Provider>
    );
}